import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Buffer } from 'buffer';
import * as svg from './svg/index.json';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-svg-renderer',
  templateUrl: './svg-renderer.component.html',
  styleUrls: ['./svg-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvgRendererComponent implements OnInit {
  @Input() svg: string;

  svgContent: SafeHtml;

  constructor(private sanitized: DomSanitizer) {}

  ngOnInit(): void {
    let content = Buffer.from(svg[this.svg + '.svg'], 'base64').toString(
      'utf8'
    );
    content = content.replace('<?xml version="1.0" encoding="utf-8"?>', '');
    // content = content.replace(/(\r\n|\n|\r)/gm, '');
    // content = content.replace(/<style type="text\/css">\n?(.*?)\n?<\/style>/gi, '');
    this.svgContent = this.sanitized.bypassSecurityTrustHtml(
      content.replace(
        '<!-- Generator: Adobe Illustrator 23.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
        ''
      )
    );
  }
}
